import mediaCheck from 'mediacheck';

export function Modal(el) {
  this.el = el;
  this.isOpen = false;

  let openButton = this.el.querySelector('.modal__open-button');
  const closeButton = this.el.querySelector('.modal__close-button');
  const modalContent = this.el.querySelector('.modal');
  const modalTitle = this.el.querySelector('.modal__title');
  const content = this.el.querySelector('.modal__content');
  const overlay = this.el.querySelector('.modal-overlay');
  const body = document.querySelector('body');

  let onClose = () => {};

  const setOpenButtonRef = (element) => {
    openButton = element;
  };

  const setOnClose = (fn) => {
    onClose = fn;
  };

  const setTitle = (title) => {
    modalTitle.textContent = title;
  };

  const setModalClass = (modalClass) => {
    modalContent.classList.add(modalClass);
  };

  const handleESC = (e) => {
    if (e.key === 'Escape') this.closeAndReturnFocus();
  };

  this.handleKeyPress = (e) => {
    handleESC(e);
  };

  this.trapFocus = (e) => {
    if (this.isOpen && !modalContent.contains(e.target)) {
      e.stopPropagation();

      // This will focus on the correct element based on tab vs. shift-tab
      if (e.relatedTarget === modalContent) {
        closeButton.focus();
      } else {
        modalContent.focus();
      }
    }
  };

  this.open = () => {
    overlay.hidden = false;
    modalContent.hidden = false;
    // no scrollbars in the page when a modal dialog is seen
    body.style.overflow = 'hidden';

    // Handles keydown events
    document.addEventListener('keydown', this.handleKeyPress);
    document.addEventListener('focusin', this.trapFocus);
    this.isOpen = true;
  };

  this.close = () => {
    overlay.hidden = true;
    modalContent.hidden = true;
    // reset overflow to visible when modal is closed
    body.style.overflow = 'visible';
    // Handles keydown events

    document.removeEventListener('focusin', this.trapFocus);
    document.removeEventListener('keydown', this.handleKeyPress);
    this.isOpen = false;
    onClose();
  };

  this.closeAndReturnFocus = () => {
    this.close();
    // focus goes back to the tooltip button
    openButton?.focus();
  };

  // After the modal has transitioned, set focus on the correct element
  modalContent.addEventListener('transitionend', (e) => {
    if (e.propertyName !== 'visibility') return;

    if (this.isOpen) {
      modalTitle.focus();
    } else {
      openButton?.focus();
    }
  });

  openButton?.addEventListener('click', this.open);
  closeButton.addEventListener('click', this.closeAndReturnFocus);
  overlay.addEventListener('click', this.closeAndReturnFocus);

  return {
    open: this.open,
    close: this.closeAndReturnFocus,
    modalContent: content,
    setOpenButtonRef,
    setOnClose,
    setTitle,
    setModalClass,
  };
}

export const initializeModals = (modals) => {
  const modalComponents = [...modals].map((el) => new Modal(el));

  // Close modals on viewport change.
  mediaCheck({
    media: '(min-width: 37.5rem)',
    both() {
      modalComponents.forEach((modal) => {
        modal.close();
      });
    },
  });
};
